export default {
  id: '',
  name: '',
  description: '',
  status: true
};
